module.exports = __webpack_public_path__ + "static/media/redpack2.0e6ece24.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/redpack2.png
// module id = 2014
// module chunks = 6